import { __awaiter } from "tslib";
import PreFetchService from './preFetchService';
/** The name of the module */
export const name = 'LoyaltyOfferService';
class LoyaltyOfferService {
    /**
       * Get offers from prefetch server call
       */
    static getOffers() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!LoyaltyOfferService.shouldFetch()) {
                return { offers: {} };
            }
            try {
                // Fetch data from the PreFetchService for the loyalty offers key
                const offersJson = yield PreFetchService.getData(LoyaltyOfferService.immediateFetchKey);
                // Parse the JSON and return the offers
                return JSON.parse(offersJson);
            }
            catch (_a) {
                throw Error('Failed to fetch loyalty offers');
            }
        });
    }
    static shouldFetch() {
        return PreFetchService.hasKey(LoyaltyOfferService.immediateFetchKey);
    }
}
// Prefetch key for loyalty offers data
LoyaltyOfferService.immediateFetchKey = 'loyaltyOffers';
export default LoyaltyOfferService;
